import React, { useContext, useEffect, useState } from 'react';
import { Button} from '@material-ui/core';
import { OrderDetails, OrdersContext, UserContext } from '../../App';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import CheckoutCard from '../CheckoutCard/CheckoutCard';
import Price from '../Price/Price';
import { Link } from 'react-router-dom';
import './Chekout.css'

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
      width: '25ch',
    },
  },
}));


const Checkout = () => {
    const classes = useStyles();
    const [orderDetails, setOrderDetails] = useContext(OrderDetails);
    const [orders, setOrders] = useContext(OrdersContext);
    const [loggedInUser, setLoggedInUser] = useContext(UserContext);
    const [disabled, setDisabled] = useState(true);
    const handleSubmit = (e) => {
        e.preventDefault();
        const detail = {...orderDetails}
        setOrderDetails(detail)
        setDisabled(false)
    }
    useEffect(() => {
        fetch('https://red-onion-server-01.herokuapp.com/orders?email=' + loggedInUser.email)
        .then(res => res.json())
        .then(data => setOrders(data))
    }, [loggedInUser.email])

    const placeOrder = () => {
        fetch('https://red-onion-server-01.herokuapp.com/placeOrder?email=' + loggedInUser.email, {
            method: 'DELETE',
        })
    }

    return (
        <div className="container mt-5 d-flex checkout-container">
            <div className="col-md-6">
                <h3 style={{fontWeight: '400'}}>Edit Delivery Details</h3>
                <hr style={{borderColor: 'gray'}}/>
                <form action="" style={{marginTop: '40px'}} onSubmit={handleSubmit} className={classes.root}>
                
                <TextField id="filled-basic" label="Delivery" variant="filled" color="secondary" style={{width: '500px', marginBottom: '20px'}} InputProps={{ disableUnderline: true }} defaultValue="Deliver to door"/>
                
                <TextField id="filled-basic" label="Road house" variant="filled" color="secondary" name="road" style={{width: '500px', marginBottom: '20px'}} InputProps={{ disableUnderline: true }} onBlur={(e) => setOrderDetails({...orderDetails, [e.target.name] : e.target.value})} required/>
                
                <TextField id="filled-basic" label="Flat, suit or floor" variant="filled" color="secondary" name="floor" style={{width: '500px', marginBottom: '20px'}} InputProps={{ disableUnderline: true }} onBlur={(e) => setOrderDetails({...orderDetails, [e.target.name] : e.target.value})} required/>
                
                <TextField id="filled-basic" label="Bussiness Name" variant="filled" color="secondary" style={{width: '500px', marginBottom: '20px'}} InputProps={{ disableUnderline: true }} />
                
                <TextField id="filled-basic" label="Add delivery instruction" variant="filled" color="secondary" style={{width: '500px', marginBottom: '20px'}} InputProps={{ disableUnderline: true }} multiline rows={2}/>
                <Button variant="contained" color="secondary" style={{width: '500px', padding: '10px'}} type="submit">Save and Continue</Button>
                </form>
            </div>
            {(orders.length > 0) && <div className="col-md-6 order-details">
                <p>From <b>Red Onion Restaurant</b></p>
                <p>Arriving in 20-30 min</p>
                <p>{orderDetails.road}</p>
                <div>
                {
                    orders.map(order => <CheckoutCard order={order}/>)
                }
                </div>
                <div>
                    <Price order={orders}/>
                    <Link to="/shipment" style={{textDecoration: 'none'}}><Button variant="contained" color="secondary" style={{padding: '10px 100px'}} disabled={disabled} onClick={placeOrder}>Place Order</Button></Link>
                </div>
            </div>}
        </div>
    );
};

export default Checkout;